import React from "react";
import { useEffect,useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link,useLocation } from "react-router-dom";
import UseLangLstQuery from "Apis/LangTxtInqApi";
import"Assets/css/MembFind.css";
import MenbFindIdLstApi from "Apis/MenbFindIdLstApi";
import ApiError from "Utils/ApiError";

const AppMembFindIdRsltUi = () => {
    const location = useLocation();
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const [loginIdLstState,setLoginIdLstState] = useState([]);
    
    useEffect(()=> {
        MenbFindIdLstApi(location.state?.idntMthdCd).then((resp) => {
            switch(resp.apiHdr.code) {
                case "COMM0000":
                    setLoginIdLstState(resp.apiBody);
                    break;
                default:
                    ApiError(langData,resp.apiHdr.code);    
                    break;
            }
        });
    },[])
    return(
        <div className="loginInputWrap">
        <Helmet>
            <title>BE@RBRICK CONNECT - Find ID</title>
        </Helmet>
        <div className="membJoinForm">
            <div className="membFindTitl membFindRsltTitl">
                <h1>{langData&&langData.MEMB_FIND_ID_MAIN_TITL_00}</h1>
                {/* 아이디 찾기 */}
            </div>
            <div className="membFindRsltTxtWrap">
                <p>{langData&&langData.MEMB_FIND_ID_RSLT_DESC_00} <span>{loginIdLstState.length}</span>{langData&&langData.MEMB_FIND_ID_RSLT_DESC_01}</p>
                <p>{langData&&langData.MEMB_FIND_ID_RSLT_DESC_02}</p>
            </div>
            <div className="membFindRsltUl">
                <ul>
                    {loginIdLstState&&loginIdLstState.map((key:any) => (
                        <li>
                            <div className="loginIdInfo">
                                <p>{key.loginId}</p>
                                {key.appConnectYn === "Y" && <span className="appConnect">{langData&&langData.MEMB_FIND_ID_APP_CONNECT_LBL_00}</span>}
                                <p className="joinDtime">({key.joinDtime})</p>
                            </div>
                            {key.loginKindCd == "MGP"?
                                <Link to={"/Connect/MembFindPw/FindPwInput"} state={{
                                    membId: key.loginId,
                                    idntMthdCd: location.state?.idntMthdCd,
                                    isAuthenticated: true  // 이미 인증된 상태임을 표시
                                }} className="loginBtn">
                                    <p>{langData&&langData.MEMB_FIND_PASSWD_SET_BTN_00}</p>
                                </Link>
                                :
                                <></>
                            }
                        </li>
                    ))}

                </ul>
                <div className="nextBtnWrap">
                    <Link to={"/Connect/Login"} className="loginBtn" >
                        {langData&&langData.MEMB_FIND_LOGIN_PAGE_BTN_00}
                    </Link>
                </div>
            </div>
        </div>

        </div>
    )
}

export default AppMembFindIdRsltUi;